export default {
  languages: ['en', 'de'],
};
